import FooterModal from './footerModal'
import { StyledModal } from './index.styled'
import { CloseOutlined } from '@ant-design/icons'
import { useModal } from 'hooks'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { commonSelector } from 'store/commonSlice'

const ModalLayout = () => {
  const { modal, componentModal } = useSelector(commonSelector)
  const { open, invalid, loading } = modal
  const [height, setHeight] = useState(700)
  const { close, modalSetting, emitEvent, actionWhenClose } = useModal()
  const handleOnClose = () => {
    if (modalSetting.emitEvent) {
      emitEvent(modalSetting.emitEvent)
      return
    }
    close(false)
  }

  useEffect(() => {
    setHeight(window.screen.availHeight - 120)
  }, [])

  return (
    <StyledModal
      $height={height}
      open={open}
      confirmLoading={loading}
      cancelButtonProps={{ disabled: loading }}
      okButtonProps={{ disabled: invalid }}
      closeIcon={modalSetting?.closeIcon || <CloseOutlined />}
      onOk={() => {}}
      onCancel={handleOnClose}
      style={{
        maxHeight: modalSetting?.maxHeight,
        maxWidth: modalSetting?.maxWidth,
        minHeight: modalSetting?.minHeight,
        minWidth: modalSetting?.minWidth,
        height: modalSetting?.height
      }}
      footer={
        <FooterModal
          okLabel={modalSetting.okLabel}
          cancelLabel={modalSetting.cancelLabel}
          sendLabel={modalSetting.sendLabel}
          onSendAction={actionWhenClose}
        />
      }
      className={`${modalSetting.isDocument ? 'document-modal' : ''} ${
        modalSetting.footer === null ? 'no-footer' : ''
      }`}
      destroyOnClose
      {...modalSetting}>
      <div className={modalSetting.footer !== null ? 'container-body' : ''}>
        {open && componentModal}
      </div>
    </StyledModal>
  )
}

export default ModalLayout
